/** CBootScene 載入與各 Scene 播放共用的固定音訊 key。 */
export const AudioKey = {
  TileStack: 'sfx-tile-stack',
  Tenpai: 'sfx-tenpai',
  UIClick: 'sfx-ui-click',
  BGMLobby: 'bgm-lobby',
  BGMTable: 'bgm-table',
  BGMTenpai: 'bgm-tenpai',
} as const;

export const BGMTrack = {
  Lobby: AudioKey.BGMLobby,
  Table: AudioKey.BGMTable,
  Tenpai: AudioKey.BGMTenpai,
} as const;
export type TBGMTrack = (typeof BGMTrack)[keyof typeof BGMTrack];

export const BGM_KEYS: readonly TBGMTrack[] = [BGMTrack.Lobby, BGMTrack.Table, BGMTrack.Tenpai];

/** 原 APP 啟動時隨機選定一組角色語音，整次執行期間沿用。 */
export const VoicePack = {
  Amy: 'amy',
  AmyTaiwanese: 'amy-taiwanese',
  Cindy: 'cindy',
  CindyTaiwanese: 'cindy-taiwanese',
  Jack: 'jack',
  JackTaiwanese: 'jack-taiwanese',
  James: 'james',
  JamesTaiwanese: 'james-taiwanese',
  Ricky: 'ricky',
  RickyTaiwanese: 'ricky-taiwanese',
} as const;
export type TVoicePack = (typeof VoicePack)[keyof typeof VoicePack];

export const VOICE_PACKS = [
  VoicePack.Amy,
  VoicePack.AmyTaiwanese,
  VoicePack.Cindy,
  VoicePack.CindyTaiwanese,
  VoicePack.Jack,
  VoicePack.JackTaiwanese,
  VoicePack.James,
  VoicePack.JamesTaiwanese,
  VoicePack.Ricky,
  VoicePack.RickyTaiwanese,
] as const;

export const VoiceCue = {
  Chi: 'chi',
  Pong: 'pong',
  Kong: 'kong',
  Win: 'win',
  SelfDraw: 'self-draw',
} as const;
export type TVoiceCue = (typeof VoiceCue)[keyof typeof VoiceCue];

export const VOICE_CUES = [
  VoiceCue.Chi,
  VoiceCue.Pong,
  VoiceCue.Kong,
  VoiceCue.Win,
  VoiceCue.SelfDraw,
] as const;

/** 原 APP 另行隨機選 Amy／Cindy，供開局、補花與流局三種語音共用。 */
export const StartVoicePack = {
  Amy: 'amy',
  Cindy: 'cindy',
} as const;
export type TStartVoicePack = (typeof StartVoicePack)[keyof typeof StartVoicePack];

export const START_VOICE_PACKS = [StartVoicePack.Amy, StartVoicePack.Cindy] as const;

export const StartVoiceCue = {
  Start: 'start',
  Flower: 'flower',
  Draw: 'draw',
} as const;
export type TStartVoiceCue = (typeof StartVoiceCue)[keyof typeof StartVoiceCue];

export const START_VOICE_CUES = [
  StartVoiceCue.Start,
  StartVoiceCue.Flower,
  StartVoiceCue.Draw,
] as const;

export const voiceAudioKey = (pack: TVoicePack, cue: TVoiceCue): string => `voice-${pack}-${cue}`;

export const startVoiceAudioKey = (pack: TStartVoicePack, cue: TStartVoiceCue): string =>
  `start-voice-${pack}-${cue}`;

/** 可注入亂數的選擇器，讓「每次啟動隨機選語音組」能穩定測試。 */
export const selectRandomAudioItem = <T>(
  items: readonly [T, ...T[]],
  random: () => number = Math.random
): T => {
  const index = Math.min(items.length - 1, Math.floor(random() * items.length));
  return items[index]!;
};
